/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Brand_FooterInputs */

const tr_mascot_chat_brand_footer = /** @type {(inputs: Mascot_Chat_Brand_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse™ ChatBot · AI yazılımıdır`)
};

const en_mascot_chat_brand_footer = /** @type {(inputs: Mascot_Chat_Brand_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse™ ChatBot · AI software`)
};

const de_mascot_chat_brand_footer = /** @type {(inputs: Mascot_Chat_Brand_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse™ ChatBot · KI-Software`)
};

const ru_mascot_chat_brand_footer = /** @type {(inputs: Mascot_Chat_Brand_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse™ ChatBot · Программное обеспечение с ИИ`)
};

/**
* | output |
* | --- |
* | "Emonse™ ChatBot · AI software" |
*
* @param {Mascot_Chat_Brand_FooterInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_brand_footer = /** @type {((inputs?: Mascot_Chat_Brand_FooterInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Brand_FooterInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_brand_footer(inputs)
	if (locale === "de") return de_mascot_chat_brand_footer(inputs)
	if (locale === "ru") return ru_mascot_chat_brand_footer(inputs)
	return tr_mascot_chat_brand_footer(inputs)
});